import SanityBlockRenderer from './renderer';

export default SanityBlockRenderer;

export * from './types';
export { PassthroughComponent } from './helpers';
export { createFixedTextOverrides, createFixedTypographyConfig } from './renderer';
